<template>
  <div class="hidden-md-down">
    <div class="icon-bar">
      <a href="https://ptwist.csd.auth.gr/home" target="_blank" data-toggle="tooltip"
         title="Go to the PlasticTwist Dashboard">
        <icon :name="{ prefix: 'fas', iconName: 'columns' }" type="ptwist" rounded
              class="mb-2 text-white ptwist-module">
        </icon>
      </a>
      <a @click="modalWallet = true" title="Download the PlasticTwist Wallet">
        <icon :name="{ prefix: 'fas', iconName: 'wallet' }" type="ptwist" rounded
              class="mb-2 text-white ptwist-module">
        </icon>
      </a>
      <a target="_blank" href="https://play.google.com/store/apps/details?id=com.nurogames.plastictwist&hl=en"
         title="Download the PlasticHeroes Game"
      >
        <icon :name="{ prefix: 'fas', iconName: 'gamepad' }" type="ptwist" rounded
              class="mb-2 text-white ptwist-module">
        </icon>

      </a>

    </div>
    <modal :show.sync="modalWallet">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Select from the available platforms</h5>
      </template>
      <div class="text-center">
        <a href="https://apps.apple.com/gr/app/plastic-token-wallet/id1457237942" class="mr-2" target="_blank">
          <base-button
            class="mb-3 mb-sm-0 bg-blue text-white"
            type="button"
            :icon="{ prefix: 'fab', iconName: 'app-store-ios'}">
            iOS
          </base-button>
        </a>
        <a href="https://play.google.com/store/apps/details?id=eu.ptwist" target="_blank">
          <base-button
            class="mb-3 mb-sm-0 bg-green text-white"
            type="button"
            :icon="{ prefix: 'fab', iconName: 'google-play'}">
            Android
          </base-button>
        </a>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="modalWallet = false">Close</base-button>
      </template>
    </modal>
  </div>
</template>
<script>

export default {
  data: () => ({
    modalWallet: false
  })
}
</script>
<style scoped>
  .modal-dialog {
    width: 300px !important;
  }

  .icon-bar {
    position: fixed;
    top: 35%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-left: -100px
  }

  .icon-bar a {
    display: block;
    text-align: center;
    padding: 16px;
    transition: all 0.3s ease;
    color: white;
    font-size: 20px;
  }

  .ptwist-module:hover {
    background-color: rgb(255, 193, 7);
  }

  .ptwist-module {
    -webkit-transition: background-color 0.5s; /* Safari */
    transition: background-color 0.5s;
  }

</style>
